<template>
  <div>
    <h5>{{property}}</h5>
    <table class="table table-responsive">
      <thead>
        <tr>
          <th>{{property}}</th>
          <th>Win%</th>
          <th>Count</th>
          <th>RPR</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="property in dataToShow">
          <td class="clickable" @click="filter(property.name)">{{property.name}}</td>
          <td>{{property.winPercentage}}</td>
          <td>{{property.count}}</td>
          <td>{{property.rpr.toFixed(2)}}</td>
        </tr>
      </tbody>
    </table>
    <i v-if="!expanded" class="material-icons md-24 clickable" @click="showAll" >add</i>
    <i v-if="expanded" class="material-icons md-24 clickable" @click="showAbridged" >remove</i>
  </div>
</template>

<script>
const reducedTableSize = 5
export default {
  name: 'ReportSuccessByLocationTable',
  components: {

  },
  props: ['report', 'property','reloadCounter'],
  data () {
    return {
      title: 'Report',
      tableData: undefined,
      dataToShow: undefined,
      expanded: false
    }
  },
  methods: {
    showAll: function() {
      this.dataToShow = this.tableData
      this.expanded = true
    },
    showAbridged: function() {
      this.dataToShow = this.tableData.slice(0,reducedTableSize)
      this.expanded = false
    },
    loadTable: function () {
      this.tableData = this.report.successByProperty(this.property)
      this.dataToShow = this.tableData.slice(0,reducedTableSize)
      this.expanded = false
    },
    filter: function (value) {
      this.$emit('filter',value)
    }
  },
  watch: {
    reloadCounter() {
      this.loadTable()
    }
  },
  mounted () {
    this.loadTable()
  }
}

</script>
